import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { StandardsProvider } from './context';
import StandardDetail from './Detail';
import NewStandard from './New';
import WrittenDirectives from './WrittenDirectives/index';
import ManageStructure from './ManageStructure';
import { ManageStructureProvider } from './ManageStructure/context';
import '../../../utils/setCaleaStandards';
import useJurisdictions from 'data_sources/useJurisdictions';

const Standards = () => {
  const { id: accreditationId, versionId } = useParams();
  const { data: jurisdictions = [] } = useJurisdictions();

  return (
    <StandardsProvider
      accreditingBodyId={accreditationId!}
      versionId={versionId!}
    >
      <Routes>
        <Route
          path='manage-structure'
          element={
            <ManageStructureProvider>
              <ManageStructure />
            </ManageStructureProvider>
          }
        />
        <Route
          path='new'
          element={<NewStandard />}
        />
        <Route
          path=':standardId/new'
          element={<NewStandard />}
        />
        <Route
          path=':standardId/jurisdiction/:jurisdictionId/written-directives/*'
          element={<WrittenDirectives />}
        />
        <Route
          path=':standardId'
          element={<StandardDetail />}
        />
        <Route
          path=''
          element={<StandardDetail />}
        />
      </Routes>
    </StandardsProvider>
  );
};

export default Standards;
